/** Vaste testlogins — o.a. voor Groups-tab zichtbaarheid; geen productie-metingen tonen. */
export const TEST_ACCOUNT_EMAILS = [
  'test@superkonnected.nl',
  'test1@superkonnected.nl',
  'test2@superkonnected.nl',
] as const;

export function isTestAccountEmail(email: string | null | undefined): boolean {
  if (!email || typeof email !== 'string') return false;
  const normalized = email.trim().toLowerCase();
  return TEST_ACCOUNT_EMAILS.some((e) => e === normalized);
}
